module.exports = __webpack_public_path__ + "static/design-system-words-21a27fc4621fde4987ad47c15f9a62d0.png";